'use client';

import { useRouter, useSearchParams } from 'next/navigation';

import type { Provider } from '@supabase/supabase-js';

import { isBrowser } from '@kit/shared/utils';
import { If } from '@kit/ui/if';

import { MagicLinkAuthContainer } from './magic-link-auth-container';
// import { OauthProviders } from './oauth-providers';
import { PasswordSignInContainer } from './password-sign-in-container';

export const SeparatorLine = () => {
  return (
    <div className="flex w-full items-center gap-[13px]">
      <div className="h-[1px] flex-grow rounded-full bg-white/20"></div>
      <div className='w-[4px] h-1 rounded-full bg-white/20'></div>
      <div className="h-[1px] flex-grow rounded-full bg-white/20"></div>
      <span className="text-[10px] font-normal leading-[15px] text-[rgba(183,184,194,0.50)]">
        Or
      </span>
      <div className="h-[1px] flex-grow rounded-full bg-white/20"></div>
      <div className='w-1 h-1 rounded-full bg-white/20'></div>
      <div className="h-[1px] flex-grow rounded-full bg-white/20"></div>
    </div>
  );
};

export function SignInMethodsContainer(props: {
  inviteToken?: string;

  paths: {
    callback: string;
    home: string;
    joinTeam: string;
  };

  providers: {
    password: boolean;
    magicLink: boolean;
    oAuth: Provider[];
  };
}) {
  const router = useRouter();
  const nextPath = useSearchParams().get('next') ?? props.paths.home;

  const redirectUrl = isBrowser()
    ? new URL(props.paths.callback, window?.location.origin).toString()
    : '';

  const onSignIn = () => {
    if (props.inviteToken) {
      const searchParams = new URLSearchParams({
        invite_token: props.inviteToken,
      });

      const joinTeamPath = props.paths.joinTeam + '?' + searchParams.toString();

      router.replace(joinTeamPath);
    } else {
      router.replace(nextPath);
    }
  };

  return (
    <div className="space-y-8">
      <If condition={props.providers.password}>
        <PasswordSignInContainer onSignIn={onSignIn} />
      </If>

      <If condition={props.providers.magicLink}>
        <MagicLinkAuthContainer
          inviteToken={props.inviteToken}
          redirectUrl={redirectUrl}
          shouldCreateUser={false}
        />
      </If>

      {/* <If condition={props.providers.oAuth.length}>
        <SeparatorLine />

        <OauthProviders
          enabledProviders={props.providers.oAuth}
          inviteToken={props.inviteToken}
          shouldCreateUser={false}
          paths={{
            callback: props.paths.callback,
            returnPath: props.paths.home,
          }}
        />
      </If> */}
    </div>
  );
}
